import { ReactNode } from "react"
import create from "zustand"

type popupMsg = {
  content: ReactNode
}

interface State {
  popupMsg: null | popupMsg
  setPopupMsg: (val: null | popupMsg) => void
}

const useStore = create<State>(set => ({
  popupMsg: null,
  setPopupMsg: val => set(state => ({ popupMsg: val })),
}))

export default useStore
